/* =============================================
   COLLI THEME — Main JavaScript
   ============================================= */

// ── CURSOR ──────────────────────────────────
(function initCursor() {
  const cursor = document.getElementById('colli-cursor');
  if (!cursor) return;
  document.addEventListener('mousemove', e => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top  = e.clientY + 'px';
  });
  document.querySelectorAll('a, button, [role="button"], .product-card, .collection-item').forEach(el => {
    el.addEventListener('mouseenter', () => cursor.classList.add('hovering'));
    el.addEventListener('mouseleave', () => cursor.classList.remove('hovering'));
  });
})();

// ── NAVIGATION ──────────────────────────────
(function initNav() {
  const nav = document.querySelector('.colli-nav');
  if (!nav) return;
  const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 50);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ── SCROLL REVEAL ────────────────────────────
(function initReveal() {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => observer.observe(el));
})();

// ── ACCORDION ────────────────────────────────
(function initAccordion() {
  document.querySelectorAll('.accordion-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
})();

// ── COLLECTIONS DROPDOWN ─────────────────────
(function initDropdown() {
  const btn  = document.querySelector('.collections-dropdown-btn');
  const menu = document.querySelector('.collections-dropdown-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', () => menu.classList.toggle('open'));
  document.addEventListener('click', e => {
    if (!btn.contains(e.target) && !menu.contains(e.target)) menu.classList.remove('open');
  });
})();

// ── CART DRAWER ──────────────────────────────
class ColliCart {
  constructor() {
    this.overlay = document.querySelector('.cart-drawer-overlay');
    this.drawer  = document.querySelector('.cart-drawer');
    this.body    = document.querySelector('.cart-drawer-body');
    this.total   = document.querySelector('.cart-total-price');
    this.badge   = document.querySelectorAll('.cart-badge');
    this.init();
  }

  init() {
    // Open triggers
    document.querySelectorAll('[data-open-cart]').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });
    // Close triggers
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    document.querySelectorAll('[data-close-cart]').forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });
    // Checkout
    const checkoutBtn = document.querySelector('.cart-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', () => { window.location.href = '/checkout'; });
    }
    this.refresh();
  }

  open()  { this.overlay?.classList.add('open'); this.drawer?.classList.add('open'); document.body.style.overflow = 'hidden'; this.refresh(); }
  close() { this.overlay?.classList.remove('open'); this.drawer?.classList.remove('open'); document.body.style.overflow = ''; }

  async refresh() {
    const cart = await fetch('/cart.js').then(r => r.json()).catch(() => ({ items: [], total_price: 0 }));
    const count = cart.item_count || 0;
    this.badge.forEach(b => b.textContent = count);
    if (this.total) this.total.textContent = '€ ' + (cart.total_price / 100).toFixed(2).replace('.', ',');
    if (this.body) this.renderItems(cart.items || []);
  }

  renderItems(items) {
    if (!items.length) {
      this.body.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty-icon">🛒</div>
          <p class="cart-empty-text">Ihr Warenkorb ist leer.</p>
        </div>`;
      return;
    }
    this.body.innerHTML = items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item-image" src="${item.image}" alt="${item.title}" onerror="this.src='https://images.unsplash.com/photo-1596755094514-f87e32f85e12?w=200'">
        <div class="cart-item-info">
          <p class="cart-item-title">${item.product_title}</p>
          <p class="cart-item-price">€ ${(item.price / 100).toFixed(2).replace('.', ',')}</p>
          <div class="cart-item-qty">
            <button class="cart-qty-btn" onclick="window.colliCart.updateQty('${item.key}', ${item.quantity - 1})">−</button>
            <span class="cart-qty-num">${item.quantity}</span>
            <button class="cart-qty-btn" onclick="window.colliCart.updateQty('${item.key}', ${item.quantity + 1})">+</button>
          </div>
        </div>
        <button class="cart-item-remove" onclick="window.colliCart.updateQty('${item.key}', 0)" title="Entfernen">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>
        </button>
      </div>`).join('');
  }

  async updateQty(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    await this.refresh();
  }

  async addItem(variantId, quantity = 1) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    this.open();
  }
}

// ── ADD TO CART (Collection page) ────────────
function initAddToCart() {
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.preventDefault(); e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.innerHTML = '<span style="letter-spacing:0.25em;font-size:10px;text-transform:uppercase">Wird hinzugefügt…</span>';
      await window.colliCart.addItem(variantId);
      btn.disabled = false;
      btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><span>In den Warenkorb</span>`;
    });
  });
}

// ── HERO PARALLAX ────────────────────────────
(function initParallax() {
  const heroContent = document.querySelector('.hero-content');
  if (!heroContent) return;
  window.addEventListener('scroll', () => {
    const opacity = 1 - window.scrollY / 400;
    heroContent.style.opacity = Math.max(0, opacity);
  }, { passive: true });
})();

// ── SMOOTH ANCHOR SCROLL ──────────────────────
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
});

// ── REVIEW STARS ─────────────────────────────
(function initStars() {
  let rating = 5;
  const stars = document.querySelectorAll('.star-btn');
  stars.forEach((star, i) => {
    star.addEventListener('click', () => {
      rating = i + 1;
      stars.forEach((s, j) => s.classList.toggle('active', j < rating));
    });
  });
})();

// ── INIT ─────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  window.colliCart = new ColliCart();
  initAddToCart();
});
